import React, { Component } from "react"
import PropTypes from "prop-types"

import { bindActionCreators } from "redux"
import { connect } from "react-redux"

import { Route, Redirect } from "react-router-dom"

import { Map } from "immutable"

import * as actionCreators from "../actions"

class ProtectedRoute extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  }

  state = {}
  
  render() {
    const { component: Component, auth, actions, ...rest } = this.props

    return <Route {...rest} render={props => (
      this.props.auth.get("isAuthenticated") ?
      <Component {...props} /> :
      <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
    )} />
  }
}

const mapStateToProps = (state, ownProps) => ({
  auth: state.get("auth") || Map(),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProtectedRoute)



// WEBPACK FOOTER //
// ./src/components/ProtectedRoute.js